module.exports = __webpack_public_path__ + "img/join.e98d2f0d.png";